import { configureStore } from "@reduxjs/toolkit";
// import { useDispatch, useSelector } from "react-redux";

import userSlice from "./feature/userSlice";
import appSlice from "./feature/appSlice";
import reportSlice from "./feature/reportSlice";

import commonSlice from "./feature/supplier_app/commonSlice";
import menuSlice from "./feature/supplier_app/menuSlice";
import workflowSlice from "./feature/supplier_app/workflowSlice";
import sourcingSlice from "./feature/supplier_app/sourcingSlice";
import supplierSlice from "./feature/supplier_app/supplierSlice";
import purchasingSlice from "./feature/supplier_app/purchasingSlice";
import gatepassSlice from "./feature/supplier_app/gatepassSlice";
import singleSourcingSlice from "./feature/supplier_app/singleSourcingSlice";

import customerSlice from "./feature/customer_app/customerSlice";
import customerWorkflow from "./feature/customer_app/customerWorkflowSlice";
import preSales from "./feature/customer_app/preSalesSlice";

import customerV1Slice from "./feature/customer_app/customerV1Slice";
import logisticsSlice from "./feature/logistics_app/logisticsSlice";
import plmSlice from "./feature/plm_app/plmSlice";
import pdmSlice from "./feature/pdm_app/pdmSlice";
import inventorySlice from "./feature/inventory_app/inventorySlice";
import apAutoSlice from "./feature/ap_auto_app/apAutoSlice";
import eauctionSlice from "./feature/supplier_app/eauctionSlice";
import profitLedgerSlice from "./feature/profit_ledger/profitLedgerSlice";
import warehouseSlice from "./feature/warehouse_app/warehouseSlice";
import hrSlice  from "./feature/hr_app/hrSlice";

const store = configureStore({
  reducer: {
    user: userSlice,
    app: appSlice,
    report: reportSlice,

    common: commonSlice,
    menu: menuSlice,
    workflow: workflowSlice,
    sourcing: sourcingSlice,
    supplier: supplierSlice,
    purchasing: purchasingSlice,
    gatepass: gatepassSlice,
    singleSourcing: singleSourcingSlice,

    customer: customerSlice,
    customerWorkflow: customerWorkflow,
    preSales: preSales,

    customerV1: customerV1Slice,
    logistics: logisticsSlice,
    plm: plmSlice,
    pdm: pdmSlice,
    inventory: inventorySlice,
    apauto: apAutoSlice,
    eauctionSlice: eauctionSlice,
    profitLedgerSlice: profitLedgerSlice,
    warehouse: warehouseSlice,
    hr: hrSlice,
  },
});

export default store;

// export const useAppDispatch = useDispatch;
// export const useAppSelector = useSelector;
